// extracted by mini-css-extract-plugin
export var badge = "StrapiPricingCards-module--badge--52b41";
export var bulletPointElement = "StrapiPricingCards-module--bulletPointElement--7e359";
export var card = "StrapiPricingCards-module--card--e6e86";
export var cardContentContainer = "StrapiPricingCards-module--cardContentContainer--ea0fa";
export var cardInnerContainer = "StrapiPricingCards-module--cardInnerContainer--d0ea0";
export var cardPriceLabel = "StrapiPricingCards-module--cardPriceLabel--512cf";
export var cardPricePrice = "StrapiPricingCards-module--cardPricePrice--bdad3";
export var cardPriceTitle = "StrapiPricingCards-module--cardPriceTitle--b39d9";
export var cardsContainer = "StrapiPricingCards-module--cardsContainer--7aab4";
export var checkMarkIconContainer = "StrapiPricingCards-module--checkMarkIconContainer--1569d";
export var footer = "StrapiPricingCards-module--footer--da9ab";
export var highlighted = "StrapiPricingCards-module--highlighted--876ba";
export var inactive = "StrapiPricingCards-module--inactive--f30ef";
export var primaryCta = "StrapiPricingCards-module--primaryCta--e2ae1";
export var root = "StrapiPricingCards-module--root--89345";
export var secondaryCta = "StrapiPricingCards-module--secondaryCta--e0f97";
export var secondaryCtaStyle = "StrapiPricingCards-module--secondaryCtaStyle--2c4f4";
export var singleCard = "StrapiPricingCards-module--singleCard--b46a2";
export var title = "StrapiPricingCards-module--title--ff1a7";
export var titleContainer = "StrapiPricingCards-module--titleContainer--e111a";